var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPegiRestrictedOverlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0625 27.5C55.0625 35.0249 52.399 41.4478 47.072 46.7687C41.745 52.0895 35.3148 54.75 27.7812 54.75C20.2477 54.75 13.8175 52.0895 8.4905 46.7687C3.16351 41.4478 0.5 35.0249 0.5 27.5C0.5 19.9751 3.16351 13.5522 8.4905 8.23135C13.8175 2.91046 20.2477 0.25 27.7812 0.25C35.3148 0.25 41.745 2.91046 47.072 8.23135C52.399 13.5522 55.0625 19.9751 55.0625 27.5ZM17.592 45.2686C20.621 47.0404 24.0174 47.9263 27.7812 47.9263C33.4283 47.9263 38.2483 45.9321 42.2414 41.9436C46.2345 37.9551 48.231 33.1406 48.231 27.5C48.231 23.7405 47.3441 20.348 45.5702 17.3224L17.592 45.2686ZM10.269 38.1351L38.4285 10.0078C35.285 8.05173 31.7359 7.07368 27.7813 7.07368C22.1342 7.07368 17.3142 9.06792 13.3211 13.0564C9.32803 17.0449 7.3315 21.8594 7.3315 27.5C7.3315 31.4502 8.31067 34.9952 10.269 38.1351Z",
    fill: "#CFCFCF",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPegiRestrictedOverlay);
export default __webpack_public_path__ + "static/media/ic_pegi-restricted-overlay.ca25bb0d1d20202b22e92f073ed86def.svg";
export { ForwardRef as ReactComponent };